<template>
  <div class="body">
    <div class="section-copy-copy wf-section">
      <p class="paragraph-5">Our Team</p>
    </div>
    <div class="section-2 wf-section"><a name="staff"></a>
      <div class="container w-container">
        <h1 class="heading">Staff</h1>
        <div class="div-block-7">
          <div v-for="member in site.staff_members" :key=member.staff_name class="div-block-8">
            <img :src="member.staff_image" />
            <p class="paragraph-6">{{ member.staff_name}}<br />{{ member.staff_position }}</p>
          </div>
        </div>
      <div class="div-block-10" id="directors"></div>
      <h1 class="heading">Board of Directors</h1>
      <div class="div-block-7">
        <div v-for="member in site.board_members" :key=member.full_name class="div-block-8">
          <img :src="member.board_member_image" />
          <p class="paragraph-6">{{ member.full_name}}<br />{{ member.board_member_position }}</p>
        </div>
    </div>
    <div class="container-3 w-container" id="supporters">
      <h1 class="heading yearly">Year Round Supporters</h1>
      <h2 class="heading-3">Gold Level</h2>
      <div class="flexycontainer">
        <div v-for="supporter in site.gold_supporters" :key=supporter.dublab_gold_supporter_name  class="div-block-15">
          <div class="div-block-16">
            <img :src="supporter.dublab_gold_supporter_image"  />
          </div>
          <div class="div-block-17 gold">
            <h5 class="heading-2"> {{ supporter.dublab_gold_supporter_name }} </h5>
            <p class="paragraph-9"> {{ supporter.dublab_gold_supporter_description }} </p>
          </div>
        </div>
      </div>
      <h2 class="heading-3">Silver Level</h2>
      <div class="flexycontainer mids">
        <div v-for="supporter in site.silver_supporters" :key=supporter.dublab_silver_supporter_name class="div-block-15 mids">
          <div class="div-block-16">
            <img :src="supporter.dublab_silver_supporter_image" />
          </div>
          <div class="div-block-17 silver">
            <h5 class="heading-2"> {{ supporter.dublab_silver_supporter_name }} </h5>
            <p class="paragraph-9"> {{ supporter.dublab_silver_supporter_description }} </p>
          </div>
        </div>
      </div>
      <h2 class="heading-3">Bronze Level</h2>
      <div class="flexycontainer">
        <div v-for="supporter in site.bronze_supporters" :key=supporter.dublab_bronze_supporter_name class="div-block-15">
          <div class="div-block-16">
            <img :src="supporter.dublab_bronze_supporter_image" />
          </div>
          <div class="div-block-17 bronze">
            <h5 class="heading-2"> {{ supporter.dublab_bronze_supporter_name }} </h5>
            <p class="paragraph-9"> {{ supporter.dublab_bronze_supporter_description }} </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-2 w-container">
      <div class="div-block-10"></div>
      <h1 class="heading">Foundations and Grantmakers</h1>
      <div class="flexycontainer">
        <div v-for="foundation in site.foundations" :key=foundation.foundation_name class="logoholder">
          <img :src="foundation.foundation_image" class="image-9" />
        </div>
        
      </div>
      <div class="div-block-10"></div>
      <h1 class="heading">Major Donors</h1>
      <div class="flexycontainer rogueflex">
        <div v-for="person in site.major_donors" :key=person.full_name class="div-block-13">
          <span class="text-block-6"> 
            {{ person.full_name }}
          </span>
        </div>
      </div>
      <div class="div-block-10"></div>
      <h1 class="heading">Supporter Circle Members</h1>
      <div class="flexycontainer rogueflex">
        <div v-for="person in site.supporters_circle" :key=person.full_name class="div-block-11">
          <span class="text-block-6"> 
            {{ person.full_name }}
          </span></div>
      </div>
    </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mixin
  }

  from "@/lib/content-state";

  export default {
    name: "Team",
    mixins: [mixin]
  }

  ;
</script>
<style scoped>
  .section {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 60vh;
    max-height: 800px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    background-image: url("../assets/images/image_dublab_05_l.jpg");
    background-position: 50% 75%;
    background-size: cover;
  }

  .container {
    max-width: 66%;
  }

  .gold {
    padding-left: 20px;
    border-left: 2px solid gold;
  }

  .silver {
    padding-left: 20px;
    border-left: 2px solid #c0c0c0;
  }

  .bronze {
    padding-left: 20px;
    border-left: 2px solid #b8860b;
  }

  .w-container {
    margin: 0 auto;
    margin-top: 80px;
  }

  .paragraph {
    width: 70%;
    margin-right: auto;
    margin-bottom: 0px;
    margin-left: auto;
    font-family: Suisseneue, sans-serif;
    font-size: 18px;
    line-height: 25px;
  }

  .mission-statement {
    display: block;
    height: 340px;
    margin-top: 60px;
    margin-bottom: 40px;
    border: 1px solid #000;
    border-radius: 40px;
    font-family: Adieu, sans-serif;
    font-size: 36px;
    line-height: 40px;
    font-weight: 300;
    text-align: center;
  }

  .text-block {
    font-family: Suisseintlmono, sans-serif;
    font-size: 16px;
    line-height: 18px;
    font-weight: 400;
    text-transform: uppercase;
  }

  .text-block-2 {
    margin-top: 40px;
    font-size: 14px;
  }

  .paragraph-2 {
    max-width: 65%;
  }

  .paragraph-3 {
    width: 75%;
    margin-top: 10px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 40px;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
    font-size: 32px;
    line-height: 38px;
  }

  .directory-row {
    margin-bottom: 60px;
    border-top: 1px solid #000;
    font-size: 13px;
  }

  .text-block-3 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-family: Suisseintlmono, sans-serif;
    text-transform: uppercase;
  }

  .img-row {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    margin-top: 0px;
    padding-top: 0px;
    -webkit-justify-content: space-around;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .img-holder {
    position: relative;
    height: 180px;
    margin-right: 2%;
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    -ms-grid-row-align: auto;
    align-self: auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
    border-style: none;
    border-width: 1px;
    border-color: transparent;
    border-radius: 12px;
    text-align: left;
  }

  .div-block-2 {
    width: 32%;
    height: 180px;
    -o-object-fit: none;
    object-fit: none;
  }

  .image {
    max-height: 100%;
    min-width: 100%;
    border-radius: 15px;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .image-2 {
    display: inline-block;
    max-height: 100%;
    min-height: 100%;
    min-width: 100%;
    border-radius: 15px;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: 50% 50%;
    object-position: 50% 50%;
  }

  .image-3 {
    max-height: 100%;
    min-width: 100%;
    border-radius: 15px;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .text-block-4 {
    position: absolute;
    left: 0%;
    top: 0%;
    right: auto;
    bottom: auto;
    display: inline-block;
    margin-top: 10px;
    margin-left: 15px;
    float: none;
    clear: left;
    font-family: Adieu, sans-serif;
    color: #fff;
    font-size: 18px;
    line-height: 24px;
    cursor: pointer;
  }

  .mission-statement-copy {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 340px;
    margin-top: 60px;
    margin-bottom: 40px;
    padding: 30px;
    border: 1px dashed #000;
    border-radius: 30px;
    font-family: Adieu, sans-serif;
    font-size: 36px;
    line-height: 40px;
    font-weight: 300;
    text-align: center;
  }

  .div-block-3 {
    width: 33%;
  }

  .image-4 {
    height: auto;
    max-height: 100%;
    min-height: 100%;
    min-width: 100%;
    -o-object-fit: contain;
    object-fit: contain;
  }

  .link-block {
    color: #000;
    text-decoration: none;
  }

  .div-block-4 {
    height: 180px;
    border-top: 1px solid #000;
    border-radius: 1px;
  }

  .section-2 {
    border-top: 1px none #000;
  }

  .text-block-5 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-family: Suisseintlmono, sans-serif;
    text-transform: uppercase;
  }

  .div-block-5 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    grid-column-gap: 5%;
    grid-row-gap: 5%;
  }

  .paragraph-4 {
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
    -webkit-box-ordinal-group: 0;
    -webkit-order: -1;
    -ms-flex-order: -1;
    order: -1;
  }

  .div-block-6 {
    width: 30%;
    font-family: Adieu, sans-serif;
    font-size: 20px;
    line-height: 24px;
    font-weight: 300;
  }

  .image-5 {
    width: 100%;
    margin-top: 60px;
  }

  .paragraph-5 {
    font-family: Adieu, sans-serif;
    color: #fff;
    font-size: 80px;
    line-height: 70px;
    text-transform: none;
    text-shadow: 0 0 6px #000;
  }

  .heading {
    margin-top: 0px;
    margin-bottom: 20px;
    margin-left: auto;
    font-family: Adieu, sans-serif;
    font-size: 32px;
    line-height: 40px;
    font-weight: 300;
  }

  .heading.yearly {
    font-weight: 400;
  }

  .body {
    margin-right: auto;
    text-align: center;
  }

  .div-block-7 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 20px;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-content: flex-start;
    -ms-flex-line-pack: start;
    align-content: flex-start;
    grid-column-gap: 2.5%;
    grid-row-gap: 2.5%;
  }

  .div-block-8 {
    display: block;
    width: 23%;
    height: 15%;
    max-height: 15%;
    max-width: none;
    min-height: 15%;
    min-width: 150px;
    margin-right: 0%;
    margin-bottom: 40px;
    -webkit-box-ordinal-group: 2;
    -webkit-order: 1;
    -ms-flex-order: 1;
    order: 1;
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
  }

  .div-block-9 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 120%;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-align: baseline;
    -webkit-align-items: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-align-content: space-around;
    -ms-flex-line-pack: distribute;
    align-content: space-around;
  }

  .paragraph-6 {
    margin-top: 10px;
    font-family: Adieu, sans-serif;
    font-size: 16px;
    line-height: 20px;
    font-weight: 300;
    text-align: left;
  }

  .div-block-10 {
    margin-bottom: 50px;
    border-top: 1px solid #000;
  }

  .paragraph-7 {
    font-family: Adieu, sans-serif;
    color: #fff;
    font-size: 84px;
    line-height: 90px;
    font-weight: 300;
    text-align: center;
  }

  .section-copy {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 55vh;
    max-height: 800px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    background-image: url("../assets/images/Dublab-4.jpg");
    background-position: 50% 70%;
    background-size: cover;
  }

  .section-copy-copy {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    overflow: visible;
    height: 55vh;
    max-height: 800px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: transparent;
    background-image: url("../assets/images/dublab_blues.png");
    background-position: 50% 50%;
    background-repeat: repeat;
    background-attachment: scroll;
    -o-object-fit: fill;
    object-fit: fill;
  }

  .paragraph-8 {
    margin-top: -50px;
    padding-top: 0px;
    font-family: Adieu, sans-serif;
    color: #fff;
    font-size: 80px;
    line-height: 90px;
  }

  .image-6 {
    background-color: transparent;
    -webkit-filter: invert(100%);
    filter: invert(100%);
  }

  .image-7 {
    position: absolute;
    left: auto;
    top: auto;
    right: 0%;
    bottom: 0%;
  }

  .image-8 {
    overflow: auto;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .flexycontainer {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 60px;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -webkit-align-content: space-between;
    -ms-flex-line-pack: justify;
    align-content: space-between;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 30px;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    -ms-grid-rows: auto auto;
    grid-template-rows: auto auto;
  }

  .flexycontainer.rogueflex {
    width: 725.3359375px;
    margin-right: auto;
    margin-bottom: 80px;
    margin-left: auto;
    -webkit-justify-content: space-around;
    -ms-flex-pack: distribute;
    justify-content: space-around;
  }

  .flexycontainer.mids {
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  .logoholder {
    position: relative;
    overflow: visible;
    width: 24%;
    margin-bottom: 20px;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
    -o-object-fit: fill;
    object-fit: fill;
  }

  .image-9 {
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 100%;
    margin-bottom: 20px;
    padding-bottom: 0px;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .image-10 {
    background-color: transparent;
    -webkit-filter: invert(100%);
    filter: invert(100%);
  }

  .image-11 {
    max-height: 80%;
    margin-top: 0px;
    margin-right: auto;
    margin-left: auto;
    padding-top: 0px;
    -webkit-filter: invert(100%);
    filter: invert(100%);
  }

  .text-block-6 {
    font-family: Suisseintlmono, sans-serif;
    font-size: 24px;
    line-height: 40px;
    font-weight: 300;
  }

  .text-block-7 {
    font-family: Suisseintlmono, sans-serif;
    font-size: 24px;
    line-height: 40px;
    font-weight: 300;
  }

  .div-block-11 {
    font-weight: 400;
  }

  .div-block-12 {
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    -ms-grid-row-align: auto;
    align-self: auto;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .div-block-13 {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .div-block-14 {}

  .grid {
    display: -ms-grid;
    display: grid;
    min-width: 100%;
    grid-auto-flow: row;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-areas: "Area";
    -ms-grid-columns: 1fr 16px 1fr;
    grid-template-columns: 1fr 1fr;
    -ms-grid-rows: auto 16px auto;
    grid-template-rows: auto auto;
  }

  .div-block-15 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 47%;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
  }

  .div-block-15.mids {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
  }

  .div-block-16 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 44%;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
  }

  .div-block-17 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    max-width: 48%;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
  }

  .heading-2 {
    margin-top: 0px;
    font-family: Suisseintlmono, sans-serif;
    font-size: 12px;
    font-weight: 700;
    text-align: left;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    padding-bottom: .2rem;
  }

  .paragraph-9 {
    font-family: Suisseneue, sans-serif;
    font-weight: 400;
    text-align: left;
    font-size: 14px;
    line-height: 20px;
  }

  .div-block-18 {
    width: 4%;
  }

  .container-2 {
    max-width: 66%;
  }

  .container-3 {
    max-width: 78%;
  }

  .image-13 {
    -webkit-filter: invert(100%);
    filter: invert(100%);
  }

  .heading-3 {
    margin-top: 0px;
    margin-bottom: 20px;
    font-family: Adieu, sans-serif;
    font-weight: 300;
    font-size: 32px;
    line-height: 44px;
  }

  .image-14 {
    min-height: 100%;
  }

  .container-4 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    max-width: 66%;
    margin-top: 80px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
  }

  @media screen and (max-width: 991px) {
    .paragraph {
      width: 100%;
    }

    .paragraph-3 {
      font-size: 20px;
      line-height: 33px;
    }

    .image-4 {
      min-height: 100%;
      -o-object-fit: scale-down;
      object-fit: scale-down;
    }

    .section-2 {
      line-height: 22px;
    }

    .paragraph-4 {
      font-size: 14px;
      line-height: 20px;
    }

    .flexycontainer.rogueflex {
      width: auto;
    }
    
    .div-block-7 {
      -webkit-justify-content: space-around;
      -ms-flex-pack: distribute;
      justify-content: center;
    }

    .div-block-15 {
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-align-self: auto;
      -ms-flex-item-align: auto;
      -ms-grid-row-align: auto;
      align-self: auto;
    }

    .div-block-15.mids {
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
    }

    .div-block-17 {
      display: none;
    }

    .image-15 {
      -webkit-box-flex: 0;
      -webkit-flex: 0 auto;
      -ms-flex: 0 auto;
      flex: 0 auto;
    }

    .container-5.dei {
      max-width: 80%;
    }

    .container-5.history {
      max-width: 80%;
    }

    .image-16 {
      height: auto;
    }

    .lilp {
      margin-top: 0px;
      font-size: 30px;
      line-height: 38px;
    }

    .keep-us-on-air {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
    }
  }

  @media screen and (max-width: 767px) {
    .container {
      max-width: 80%;
    }

    .container.mission {
      max-width: 80%;
    }

    .mission-statement {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
    }

    .text-block {
      margin-top: 20px;
      margin-bottom: 20px;
    }

    .paragraph-3 {
      padding-left: 0px;
      font-size: 17px;
      line-height: 25px;
    }

    .text-block-4 {
      font-size: 14px;
      line-height: 20px;
    }

    .div-block-4 {
      display: none;
      max-width: 100%;
      margin-right: auto;
      margin-left: auto;
    }

    .paragraph-4 {
      font-size: 12px;
      line-height: 16px;
    }

    .paragraph-5 {
      font-size: 60px;
    }

    .div-block-7 {
      -webkit-justify-content: space-around;
      -ms-flex-pack: distribute;
      justify-content: space-around;
    }

    .div-block-8 {
      min-width: 180px;
      -webkit-align-self: auto;
      -ms-flex-item-align: auto;
      -ms-grid-row-align: auto;
      align-self: auto;
      -webkit-box-flex: 0;
      -webkit-flex: 0 auto;
      -ms-flex: 0 auto;
      flex: 0 auto;
    }

    .paragraph-6 {
      font-size: 16px;
      line-height: 20px;
    }

    .container-2 {
      max-width: 80%;
    }

    .container-4 {
      max-width: 80%;
    }

    .container-5.history {
      max-width: 80%;
    }

    .paragraph-10 {
      max-width: 100%;
      -webkit-align-self: center;
      -ms-flex-item-align: center;
      -ms-grid-row-align: center;
      align-self: center;
    }

    .div-block-19 {
      width: 100%;
      -webkit-align-self: center;
      -ms-flex-item-align: center;
      -ms-grid-row-align: center;
      align-self: center;
    }

    .list-2 {
      max-width: 100%;
      -webkit-align-self: center;
      -ms-flex-item-align: center;
      -ms-grid-row-align: center;
      align-self: center;
    }

    .lilp {
      font-size: 26px;
      line-height: 34px;
    }

    .text-block-4-copy {
      font-size: 14px;
      line-height: 20px;
    }

    .heading-3-copy {
      display: block;
    }

    .goldimg {
      display: none;
    }

    .container-6 {
      max-width: 80%;
    }

    .container-7 {
      max-width: 80%;
    }
  }

  @media screen and (max-width: 479px) {
    .container {
      max-width: 85%;
    }

    .mission-statement {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
    }

    .text-block {
      margin-top: 0px;
      margin-bottom: 20px;
    }

    .paragraph-3 {
      font-size: 16px;
      line-height: 19px;
    }

    .img-row {
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: stretch;
      -webkit-align-items: stretch;
      -ms-flex-align: stretch;
      align-items: stretch;
      -webkit-align-content: stretch;
      -ms-flex-line-pack: stretch;
      align-content: stretch;
    }

    .img-holder {
      height: auto;
    }

    .paragraph-5 {
      display: block;
      margin-right: auto;
      margin-left: auto;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-align-self: auto;
      -ms-flex-item-align: auto;
      -ms-grid-row-align: auto;
      align-self: auto;
      -webkit-box-flex: 0;
      -webkit-flex: 0 auto;
      -ms-flex: 0 auto;
      flex: 0 auto;
      font-size: 44px;
      line-height: 54px;
      text-align: center;
    }

    .heading {
      font-size: 28px;
    }

    .div-block-7 {
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
    }

    .div-block-8 {
      width: 70%;
    }

    .flexycontainer {
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
    }

    .logoholder {
      width: 100%;
    }

    .div-block-15 {
      width: 100%;
    }

    .values {
      font-size: 24px;
      line-height: 30px;
      text-align: center;
    }

    .container-5.dei {
      max-width: 80%;
    }

    .paragraph-10 {
      font-size: 18px;
      line-height: 24px;
    }

    .majordonor {
      font-size: 18px;
      line-height: 24px;
    }

    .lilp {
      font-size: 20px;
      line-height: 28px;
    }

    .text-block-4-copy {
      font-size: 12px;
      line-height: 16px;
    }

    .container-6 {
      display: none;
    }

    .container-7 {
      display: none;
      max-width: 95%;
    }
  }

  @font-face {
    font-family: "Adieu";
    src: url("../assets/fonts/Adieu-Regular.otf") format("opentype");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Suisseintlmono";
    src: url("../assets/fonts/SuisseIntlMono-Regular.otf") format("opentype");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Suisseintlmono";
    src: url("../assets/fonts/SuisseIntlMono-Bold.otf") format("opentype");
    font-weight: 700;
    font-style: bold;
    font-display: swap;
  }

  @font-face {
    font-family: "Adieu";
    src: url("../assets/fonts/Adieu-Light.otf") format("opentype");
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Suisseneue";
    src: url("../assets/fonts/SuisseNeue-Regular.otf") format("opentype");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
</style>